export const MESSAGE_ZONE_LAYOUT = "layoutZone";
